<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container v-show="Details">
        <v-card style="border: 1px solid">
          <v-toolbar :color="appColor">
            <v-card-title class="headline mb-1">
              <span style="color:white"> เพิ่มรายชื่อผู้เข้าร่วม</span>
            </v-card-title>
          </v-toolbar>
          <v-list-item>
            <v-row>
              <v-col cols="12">
                <v-expand-transition>
                  <v-card v-if="!Details_Cordi" style="border: 1px solid">
                    <v-row justify="center" class="d-flex justify-center">
                      <v-col cols="12" md="12">
                        <v-list>
                          <v-list-item class="justify-center">
                            <div align="center">
                              <p class="font-weight-bold">เลือกปีงบประมาณก่อนทำรายการ</p>
                            </div>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            <v-radio-group row v-model="FiscalYear" v-for="fiscalYear in FiscalYearDataSel"
                              :key="fiscalYear.year" @change="selProjFiscalYear">
                              <v-radio :value="fiscalYear.year" class="font-weight-bold"
                                :label="('' + fiscalYear.yearth)"></v-radio>
                            </v-radio-group>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            ตารางข้อมูลรายละเอียดงาน / กิจกรรม
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="ค้นหางาน / กิจกรรม"
                              single-line hide-details></v-text-field>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <v-row justify="center" class="justify-center">
                      <v-col cols="12" md="12">

                        <!--                        @click:row="GetData"-->
                        <v-data-table :headers="courseHeaders" :items="projectDataToTable" :search="search"
                          item-key="idx" :single-expand="singleExpand" :expanded.sync="expanded" class="elevation-1">
                          <template v-slot:header.Project_code>
                            <v-label fontSize="16px" fontWeight="bold">
                              รหัสแผน
                            </v-label>
                          </template>
                          <template v-slot:header.Project_name>
                            <v-label fontSize="16px" fontWeight="bold">
                              งาน / กิจกรรม
                            </v-label>
                          </template>
                          <template v-slot:item.full_Name="{ item }">
                            <div v-html="item.full_Name"></div>
                          </template>
                          <template v-slot:item.Project_Details="{ item }">
                            <v-btn text color="primary" @click="showDetails(item)">
                              เพิ่มรายชื่อ
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-list-item>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col cols="12" md="12">
                <template v-if="Details_Cordi">

                  <v-list-item class="d-none d-md-flex">
                    <v-btn outlined color="#FF5722" @click="showDetails">
                      ย้อนกลับ
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="green" class="darken-3 mr-4" @click="openExportOptionsDialog">
                      Export รายชื่อผู้เข้าร่วม (บุคลากร)
                    </v-btn>
                    <download-excel class="btn btn-default mr-4" :data="json_data_export" :fields="json_fields_export"
                      worksheet="รายชื่อผู้เข้าร่วม" :title="array_title"
                      :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'">
                      <v-btn outlined color="green" class="darken-3" @click="ExportData">
                        Export รายชื่อผู้เข้าร่วม (ทั้งหมด)
                      </v-btn>
                    </download-excel>
                  </v-list-item>
                  <v-list-item>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="#009688" @click="importExcelData('1')">
                      Import ข้อมูลบุคลากร
                    </v-btn>
                    <v-btn class="ml-4" outlined color="#009688" @click="importExcelData('2')">
                      Import ข้อมูลนักศึกษาคณะแพทย์
                    </v-btn>
                    <v-btn class="ml-4" outlined color="#009688" @click="importExcelData('3')">
                      Import ข้อมูลบุคคลภายนอก
                    </v-btn>
                  </v-list-item>
                  <v-list-item class="d-flex d-md-none">
                    <v-btn outlined color="#FF5722" @click="showDetails">
                      ย้อนกลับ
                    </v-btn>
                  </v-list-item>
                  <div align="center" class="d-flex d-md-none justify-center">
                    <download-excel class="btn btn-default mr-4" :data="json_data_export" :fields="json_fields_export"
                      worksheet="รายชื่อผู้เข้าร่วม" :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'">
                      <v-btn outlined color="green" class="darken-3" @click="ExportData">
                        Export รายชื่อผู้เข้าร่วม
                      </v-btn>
                    </download-excel>
                  </div>
                  <div align="center" class="d-flex d-md-none justify-center">
                    <v-btn class="mt-4" outlined color="#009688" @click="DialogImportEmp = true">
                      Import ข้อมูลบุคลากร
                    </v-btn>
                  </div>
                  <div align="center" class="d-flex d-md-none justify-center">
                    <v-btn v-if="false" class="mt-4" outlined color="#009688" @click="DialogImportEmp = true">
                      Import ข้อมูลบุคคลทั่วไป
                    </v-btn>
                  </div>
                  <v-card class="justify-center pa-6 mt-7">
                    <v-card-title color="primary" style="background-color: burlywood">
                      <span style="color: blue;font-weight: bold"> : {{
                        project.full_Name2.replace(/&quot;/g, '"')
                        }} ({{ project.Project_code }})</span>
                    </v-card-title>

                    <v-card-text>
                      <v-tabs v-model="tab" background-color="transparent" color="basil" show-arrows>
                        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                        <v-tab>
                          บุคลากรคณะแพทย์
                        </v-tab>
                        <v-tab>
                          นักศึกษาคณะแพทย์
                        </v-tab>
                        <v-tab>
                          บุคลากรคณะอื่น
                        </v-tab>
                        <v-tab>
                          นักศึกษาคณะอื่น
                        </v-tab>
                        <v-tab>
                          บุคคลภายนอก
                        </v-tab>
                        <v-tab>
                          นักศึกษาภายนอก
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <v-list-item>
                            <v-row class="d-flex justify-center">
                              <v-col class="d-flex justify-center" cols="12" md="6">
                                <v-radio-group v-model="TypeInsert" row>
                                  <v-radio class="font-weight-bold" label="ค้นหาโดยชื่อ / รหัสบุคลากร"
                                    value="1"></v-radio>
                                  <v-radio class="font-weight-bold" label="ค้นหาโดยตัวเลือก" value="2"></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col cols="12" md="6">
                                <v-autocomplete v-model="staffSel" label="ค้นหาบุคลากร" :items="staffData"
                                  item-text="customDetail" item-value="perid" hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                  persistent-hint clearable outlined @keyup="checkKeyEnter"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="4">
                                <v-file-input v-model="filesP" color="deep-purple accent-4" counter
                                  label="แนบไฟล์ (ถ้ามี)" multiple placeholder="เลือกไฟล์" prepend-icon="mdi-paperclip"
                                  outlined :show-size="1000" @change="FileSelect">
                                  <template v-slot:selection="{ index, text }">
                                    <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                                      {{ text }}
                                    </v-chip>

                                    <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                                      +{{ filesP.length - 2 }} File(s)
                                    </span>
                                  </template>
                                </v-file-input>
                              </v-col>
                              <v-col cols="8" md="2" class="d-flex justify-center">
                                <v-btn outlined color="primary" @click="ChooseEmpolyee_s">
                                  เพิ่ม
                                </v-btn>
                              </v-col>
                            </v-row>

                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col cols="12" md="6">
                                <v-autocomplete v-model="departSel" label="เลือกหน่วยงาน" :items="depart"
                                  item-text="dep_name" item-value="dep_id" flat solo-inverted hide-details clearable
                                  clear-icon="mdi-close-circle-outline" @change="ChooseEmpolyee"></v-autocomplete>
                              </v-col>
                            </v-row>

                          </v-list-item>
                          <v-row v-if="TypeInsert == '2'">
                            <v-col cols="12" md="6">
                              <v-card-text>
                                <v-treeview :items="items" selected-color="indigo" expand-icon="mdi-chevron-down"
                                  off-icon="mdi-checkbox-blank-circle-outline"
                                  on-icon="mdi-checkbox-marked-circle-outline"
                                  indeterminate-icon="mdi-minus-circle-outline">
                                  <template v-slot:label="{ item }">
                                    <div class="d-flex justify-space-between">
                                      <span
                                        style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                        item.name
                                        }}</span>
                                      <v-switch inset :input-value="item.switch" @change="ChooseEmp(item)"></v-switch>
                                    </div>
                                  </template>
                                </v-treeview>
                              </v-card-text>
                            </v-col>

                            <!--                                        <v-divider vertical></v-divider>-->

                            <v-col cols="12" md="6">
                              <v-card-text>
                                <div v-if="EmpData.length === 0" key="title"
                                  class="title font-weight-light grey--text pa-4 text-center">
                                  <span
                                    style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะเข้าร่วม</span>
                                </div>

                                <v-scroll-x-transition group hide-on-leave>
                                  <v-chip v-for="(selection, i) in EmpData" :key="i" color="grey" dark small
                                    class="ma-1">
                                    <v-icon left small>mdi-account-circle</v-icon>
                                    {{ selection.name }}
                                  </v-chip>
                                </v-scroll-x-transition>
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-divider v-if="TypeInsert == '2'"></v-divider>
                          <v-card-actions v-if="TypeInsert == '2'">
                            <v-btn text @click="EmpData = []">
                              Reset
                            </v-btn>

                            <v-spacer></v-spacer>

                            <v-btn class="white--text" color="green darken-1" depressed @click="SaveToTable">
                              Save
                              <v-icon right>mdi-content-save</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <div align="center" style="margin-top: 30px">
                            <v-alert dense outlined type="success" dismissible v-if="ShowAlertSuc">
                              <div v-html="MessageSuc"></div>
                            </v-alert>
                          </div>
                          <div align="center" style="margin-top: 30px">
                            <v-alert dense outlined type="error" dismissible v-if="ShowAlertErr">
                              <div v-html="MessageError"></div>
                            </v-alert>
                          </div>
                          <v-list-item class="d-flex justify-center">
                            <v-alert v-if="alertP" prominent type="error">
                              <v-row align="center" v-for="item in txtAlertP" :key="item.id">
                                <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                              </v-row>
                            </v-alert>
                          </v-list-item>
                          <v-list-item v-if="FilePerson.length > 0">
                            <template>
                              <v-row>
                                <v-col cols="12">
                                  <v-card>
                                    <v-card-title>
                                      ไฟล์ประกอบ
                                    </v-card-title>
                                    <v-container fluid>
                                      <v-row>
                                        <v-col v-for="(file_i, index) in FilePerson" :key="index"
                                          class="d-flex child-flex" cols="12" md="4">
                                          <v-card flat tile class="d-flex">
                                            <v-img v-if="file_i.type == 'image'" :src="file_i.src"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1" class="grey lighten-2" max-width="100px"
                                              max-height="100px">
                                              <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                  <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img v-else-if="file_i.type == 'pdf'" src="../../assets/Image/pdf.png"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1" class="grey lighten-2" max-width="100px"
                                              max-height="100px">
                                              <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                  <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img v-else-if="file_i.type == 'rar' || file_i.type ==  'zip'"
                                              src="../../assets/Image/winzip.png"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1" class="grey lighten-2" max-width="100px"
                                              max-height="100px">
                                              <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                  <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img v-else-if="file_i.type == 'word'" src="../../assets/Image/word.jpg"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1" class="grey lighten-2">
                                              <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                  <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img v-else-if="file_i.type == 'ppt'" src="../../assets/Image/ppt.jpg"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1" class="grey lighten-2">
                                              <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                  <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-card-actions>
                                              <template v-if="file_i.type == 'image' ||  file_i.type == 'pdf'">
                                                <v-btn text @click="ShowData(file_i.src)">
                                                  <span style="color: indigo">
                                                    เรียกดู
                                                  </span>

                                                </v-btn>
                                              </template>
                                            </v-card-actions>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list-item>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาคณะแพทย์
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="8">
                                  <v-autocomplete outlined :items="studentData" item-value="STUDENT_ID"
                                    item-text="fullName" v-model="Idstudent" label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา">
                                  </v-autocomplete>
                                  <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                    @click="insertStd('med')">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              บุคลากรคณะอื่น
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="8">
                                  <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                    item-text="FAC_NAME_THAI" v-model="IdDepart" label="ค้นหาคณะ/สังกัด"
                                    @change="GetPersonalPSU">
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="8">
                                  <v-autocomplete outlined :items="personalMedData" item-value="STAFF_ID"
                                    item-text="FULL_NAME" v-model="IdPersonal" label="ค้นหา ชื่อ - สกุล รหัสบุคลากร">
                                  </v-autocomplete>
                                  <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                    @click="insertPersonUni()">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาคณะอื่น
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="8">
                                  <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                    item-text="FAC_NAME_THAI" v-model="IdDepartStd" label="ค้นหาคณะ"
                                    @change="GetStdPSU">
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="8">
                                  <v-autocomplete outlined :items="studentUniData" item-value="STUDENT_ID"
                                    item-text="fullName" v-model="IdstudentUni"
                                    label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"></v-autocomplete>
                                  <v-btn style="margin-left: 20px;margin-top: 15px" color="primary" outlined
                                    @click="insertStd('other')">
                                    บันทึก
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              บุคคลภายนอก
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col cols="12" md="8">
                                  <v-row>
                                    <v-col cols="12" md="6">
                                      <v-text-field v-model="NameP" label="ชื่อ (name)"
                                        :error-messages="NameP == '' ? '*' : ''" :error="NameP == ''">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                      <v-text-field v-model="SurNameP" label="สกุล (surname)"
                                        :error-messages="SurNameP == '' ? '*' : ''" :error="SurNameP == ''">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="4">
                                      <v-text-field v-model="idCard" label="รหัสบัตรประชาชน">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <v-text-field v-model="affiliation" label="สังกัด">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                      <v-text-field v-model="position" label="ตำแหน่ง">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-list-item>
                                <v-row class="justify-center">
                                  <v-col cols="12" md="4">
                                    <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item class="d-flex justify-center">
                                <v-btn color="primary" outlined @click="insertDataPerson('person')">
                                  บันทึก
                                </v-btn>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              นักศึกษาภายนอก
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row class="d-flex justify-center">
                                <v-col cols="12" md="8">
                                  <v-row>
                                    <v-col cols="12" md="6">
                                      <v-text-field v-model="NameStd" label="ชื่อ (name)"
                                        :error-messages="NameStd == '' ? '*' : ''" :error="NameStd == ''">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                      <v-text-field v-model="SurNameStd" label="สกุล (surname)"
                                        :error-messages="SurNameStd == '' ? '*' : ''" :error="SurNameStd == ''">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="6">
                                      <v-text-field v-model="idCardStd" label="รหัสบัตรประชาชน">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                      <v-text-field v-model="affiliationStd" label="มหาวิทยาลัย">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-list-item>
                                <v-row class="justify-center">
                                  <v-col cols="12" md="4">
                                    <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item class="d-flex justify-center">
                                <v-btn color="primary" outlined @click="insertDataPerson('Std')">
                                  บันทึก
                                </v-btn>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                  </v-card>

                  <v-card class="mt-7">
                    <v-toolbar :color="appColor" dark flat>
                      <v-toolbar-title>รายชื่อผู้เข้าร่วม {{ RequestPerson.length }} คน</v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field v-model="searchPerson" append-icon="mdi-magnify" label="ค้นหา" single-line
                        hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headersPerson" :items="RequestPerson" :search="searchPerson">
                      <template v-slot:item.file="{item}">
                        <div align="center">
                          <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                            {{ item.files.length }} ไฟล์
                          </v-btn>
                        </div>
                      </template>
                      <template v-slot:item.type="{item}">
                        <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                          บุคลากรคณะแพทย์
                        </span>
                        <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                          นักศึกษาคณะแพทย์
                        </span>
                        <span v-if="item.registerType_id == '2'" style="color: blue">
                          บุคลากรคณะอื่น
                        </span>
                        <span v-if="item.registerType_id == '3'" style="color: blue">
                          นักศึกษาคณะอื่น
                        </span>
                        <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                          บุคคลภายนอก
                        </span>
                        <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                          นักศึกษาภายนอก
                        </span>
                      </template>
                      <template v-slot:item.join_status="{item}">
                        <span style="font-weight: bold;color: red" v-if="item.join_status == '0'">
                          รอลงทะเบียน
                        </span>
                        <span style="font-weight: bold;color: forestgreen" v-else>
                          ลงทะเบียนเข้าร่วม
                        </span>
                      </template>
                      <template v-slot:item.action="{item}">
                        <v-btn color="#F44336" outlined @click="Del_item(item)">
                          ลบ
                        </v-btn>
                      </template>
                    </v-data-table>
                    <!--                  <v-list-item class="d-flex justify-center ma-8">-->
                    <!--                    <download-excel-->
                    <!--                        class="btn btn-default"-->
                    <!--                        :data="json_data"-->
                    <!--                        :fields="json_fields"-->
                    <!--                        worksheet="รายชื่อผู้เข้าร่วมโครงการ"-->
                    <!--                        :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"-->
                    <!--                    >-->
                    <!--                      <v-btn outlined color="green" class="darken-3">-->
                    <!--                        Export รายชื่อผู้เข้าร่วมโครงการ-->
                    <!--                      </v-btn>-->
                    <!--                    </download-excel>-->
                    <!--                  </v-list-item>-->
                  </v-card>

                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog v-model="dialogLoading" persistent width="300">
        <v-card :color="appColor" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template>
        <v-snackbar v-model="snackbar" :color="color">
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>
      <v-dialog v-model="dialogFile" width="800">
        <v-card v-if="personObj != null">
          <v-card-title color="primary" style="background-color: burlywood">
            <span style="color: blue;font-weight: bold">ไฟล์ประกอบ คุณ : {{ personObj.full_Name }} ({{
              personObj.perid
              }})</span>
          </v-card-title>
          <v-card-text class="mt-4">
            <div align="center" v-for="(item,idx) in personObj.files" :key="idx">
              <span style="font-weight: bold;color: black">ไฟล์ที่ : {{ idx + 1 }} - {{ item.File_name }}</span>
              <template v-if="project.Owner">
                <v-btn text class="ml-3" color="primary" @click="downloadFiles(item)">ดาวน์โหลด</v-btn>
                <v-btn text color="primary" @click="ShowData(Openfile + item.File_path)" v-if="checkShowData(item)">
                  เรียกดู
                </v-btn>
              </template>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogFile = false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="DialogImportEmp" persistent max-width="500">
        <v-card>
          <v-card-title>
            <span style="font-weight: bold;color: #364eff">Import {{ typeImport == '1' ? 'ข้อมูลบุคลากร' : typeImport ==
              '2' ? 'ข้อมูลนักศึกษาคณะแพทย์' : "ข้อมูลบุคคลภายนอก" }}</span>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item class="d-flex justify-center mt-6">
                <v-btn text color="primary" @click="downloadTemplateEmp">ดาวน์โหลด Template ตัวอย่าง</v-btn>
              </v-list-item>
              <v-list-item class="mt-6">
                <v-file-input v-model="filesImportEmp" color="deep-purple accent-4" counter multiple
                  label="แนบไฟล์ (ถ้ามี)" placeholder="เลือกไฟล์" prepend-icon="mdi-paperclip" outlined
                  :show-size="1000" @change="FileImport">
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 5" color="deep-purple accent-4" dark label small>
                      {{ text }}
                    </v-chip>

                    <span v-else-if="index === 5" class="overline grey--text text--darken-3 mx-2">
                      +{{ filesImportEmp.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
              </v-list-item>

              <v-list-item v-if="sheets.length > 0">
                <v-select v-model="ChooseSheet" label="เลือก Sheets" :items="sheets" item-text="name" item-value="name"
                  @change="ChooseSheetAction">

                </v-select>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="closeDi_ImportDataEmp">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="DialogExamImportEmp" persistent fullscreen scrollable>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDi_ImportDataEmp">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title><span style="font-weight: bold">ตัวอย่างข้อมูลที่ต้องการนำเข้า</span></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark style="background-color: black" text class="text-h4" @click="ImportDataToDb">
                นำเข้าข้อมูล
              </v-btn>
              <v-btn dark text style="background-color: red" @click="closeDi_ImportDataEmp" class="text-h4">
                ปิด
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text style="height: 100%" class="mt-6">
            <v-list>
              <v-list-item>
                <v-data-table :headers="empHeadersAfter" :items="empData" class="elevation-2" dense style="width: 100%">
                  <template v-slot:item.file="{item}">
                    <div align="center">
                      <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                        {{ item.files.length }} ไฟล์
                      </v-btn>
                    </div>
                  </template>
                  <template v-slot:item.type="{item}">
                    <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                      บุคลากรคณะแพทย์
                    </span>
                    <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                      นักศึกษาคณะแพทย์
                    </span>
                    <span v-if="item.registerType_id == '2'" style="color: blue">
                      บุคลากรคณะอื่น
                    </span>
                    <span v-if="item.registerType_id == '3'" style="color: blue">
                      นักศึกษาคณะอื่น
                    </span>
                    <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                      บุคคลภายนอก
                    </span>
                    <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                      นักศึกษาภายนอก
                    </span>
                  </template>
                  <template v-slot:item.join_status="{item}">
                    <span style="font-weight: bold;color: red" v-if="item.join_status == '0'">
                      รอลงทะเบียน
                    </span>
                    <span style="font-weight: bold;color: forestgreen" v-else>
                      ลงทะเบียนเข้าร่วม
                    </span>
                  </template>
                  <template v-slot:item.action="{item}">
                    <v-btn color="#F44336" outlined @click="Del_item_ImportEmp(item.idEmp)">
                      ลบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-list-item>
              <div align="center" style="margin-top: 30px">
                <v-alert dense outlined type="error" dismissible v-if="ShowAlertErrImp">
                  <div v-html="MessageErrorImp"></div>
                </v-alert>
              </div>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogExportOptions" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span>เลือกข้อมูลสำหรับการ Export</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4" v-for="(field, key) in exportFields" :key="key">
                  <v-checkbox v-model="field.value" :label="field.label" :disabled="field.disabled"></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogExportOptions = false">
              ยกเลิก
            </v-btn>
            <download-excel class="btn btn-default" :data="json_data" :fields="json_fields"
              worksheet="รายชื่อผู้เข้าร่วม" :title="array_title" :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'">
              <v-btn color="green darken-1" text @click="confirmExportWithOptions">
                Export
              </v-btn>
            </download-excel>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>

<script>
import axios from "axios";
import ConstData from "../../const/Const";
import {mapActions, mapGetters} from "vuex";
import readXlsxFile from 'read-excel-file'
import Vue from "vue";
// import io from 'socket.io-client';

export default {
  name: "JoinProject",
  data() {
    return {
      dialogExportOptions: false,
      FiscalYear: null,
      FiscalYearDataSel: [],
      fiscalYear: new Date().getFullYear(),
      typeImport: null,
      array_title: [],
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      empHeaders: [],
      empHeadersAfter: [
        {text: 'รหัส', value: 'uid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ไฟล์', value: 'file'},
        {text: 'ประเภท', value: 'type'},
        {text: 'สถานะลงทะเบียน', value: 'join_status'},
        {text: '', value: 'action'}
      ],
      empData: [],
      sheets: [],
      ChooseSheet: '',
      Exec: false,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      dialogFile: false,
      DialogImportEmp: false,
      DialogExamImportEmp: false,
      personObj: null,
      alertP: false,
      ShowAlertErrImp: false,
      MessageErrorImp: '',
      txtAlertP: [],
      filesP: [],
      filesImportEmp: [],
      FilePerson: [],
      color: 'black',
      text: '',
      snackbar: false,
      // socket: io(':9898'),
      json_fields_export: {
        'ลำดับ': 'index',
        "รหัสบุคลากร/นักศึกษา/อ้างอิงบุคคลภายนอก": 'uid',
        "ชื่อ - สกุล": 'full_Name',
        "สังกัด": 'affiliation',
        "ประเภท": 'type_details',
      },
      json_data_export: [],
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
        "เลขใบอนุญาต": 'license_id',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      dialogLoading: false,
      ShowAlertSuc: false,
      MessageSuc: '',
      ShowAlertErr: false,
      MessageError: '',
      phoneOther: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      projectDataToTable: [],
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      project: null,
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      open: [1, 2],
      isLoading: false,
      tree: [],
      types: [],
      Details: true,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 5,
      vertical: false,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ProjectData: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      searchPerson: '',
      headersPerson: [
        {text: '#', value: 'uid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ไฟล์', value: 'file'},
        {text: 'ประเภท', value: 'type'},
        {text: 'สถานะลงทะเบียน', value: 'join_status'},
        {text: '', value: 'action'}
      ],
      RequestPerson: [],
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'ระดับ', value: 'Level'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ภายในประเทศ'
        },
        {
          id: '4', detail: 'ต่างประเทศ'
        },
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      exportFields: {
        employeeId: { label: 'รหัสบุคลากร', value: true, disabled: true },
        prefix: { label: 'คำนำหน้า', value: true, disabled: true },
        firstName: { label: 'ชื่อ', value: true, disabled: true },
        lastName: { label: 'นามสกุล', value: true, disabled: true },
        department: { label: 'หน่วยงาน', value: true, disabled: true },
        position: { label: 'ตำแหน่ง', value: true, disabled: true },
        religion: { label: 'ศาสนา', value: true, disabled: true },
        academicBudget: { label: 'งบวิชาการตามสิทธิ์ที่ได้รับ', value: true, disabled: false },
        remarks: { label: 'หมายเหตุ', value: true, disabled: false },
        licenseNumber: { label: 'เลขใบอนุญาต', value: true, disabled: false },
      },
      courseHeaders: [
        {text: 'รหัสแผน', value: 'Project_code'},
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: '', value: 'Project_Details'}
      ],
    }
  },
  sockets: {
    connect() {
      console.log('socket connected')
    },
    customEmit(data) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data) ' + data)
    }
  },
  watch: {
    NameStd(val) {
      console.log(this.NameStd + ' - ' + val)
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      ProjectFromFiscalYearUser: "Project/getProjectFromFiscalYearUser",
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      ProjectRound: 'Project/getProjectRound',
      PersonFiles: 'Project/getPersonFiles',
      staffData: 'Staff/getStaff',
      // AllStaff: 'Staff/getAllStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      PermissionAdmin: 'Permission/getPermission',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      JoinProjectPage: 'Project/getManageProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initProjDataFromFiscalYearUser2: "Project/initProjDataFromFiscalYearUser2",
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initPersonFileData: 'Project/initPersonFileData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeJoinProjectPage: 'Project/changeManageProjectPage'
    }),
    init: function () {
      /*this.socket.on('connect', function () {
        this.socket.emit('set-query', {
          query: [
            'cid',
            'name',
            'nameEn',
            'dob',
            'gender',
            'issuer',
            'issueDate',
            'expireDate',
            'address',
            'photo',
            'nhso'
          ]
        });
      });
      this.socket.on('smc-data', function (data) {
        console.log(data);
        if (data.status == 200) {
          this.NameStd = data.data.name.firstname
          this.SurNameStd = data.data.name.lastname
          this.idCardStd = data.data.name.cid
          this.NameStd = 'test'
          this.SurNameStd = 'test'
          this.idCardStd = 'test'
          console.log('success Data')
          console.log(this.NameStd)
          console.log(this.SurNameStd)
          console.log(this.idCardStd)
        }
      });
      this.socket.on('smc-error', function (data) {
        console.log(data);
      });
      this.socket.on('smc-removed', function (data) {
        console.log(data);
      });
      this.socket.on('smc-incorrect', function (data) {
        console.log(data);
      });
      this.socket.on('smc-inserted', function (data) {
        console.log(data);
      });*/

      ////////////////////////////////////////////////////////////////////////////////////////////
      /*this.sockets.subscribe('connect', (data) => {
        // console.log(data)
        this.text = data.description
        this.color = 'green'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-error', (data) => {
        // console.log(data)
        this.text = 'พบข้อผิดพลาด (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-removed', (data) => {
        // console.log(data)
        this.text = 'การ์ดถูกถอด (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-incorrect', (data) => {
        // console.log(data)
        this.text = 'การอ่านข้อมูลไม่ถูกต้อง โปรดตรวจสอบ การใส่การ์ด หรือ ทำความสะอาดชิปบนการ์ดแล้วลองใหม่อีกครั้ง (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-inserted', (data) => {
        // console.log(data)
        this.text = 'การ์ดถูกใส่ (' + data.description + ')'
        this.color = 'black'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-data', (data) => {
        this.text = 'อ่านข้อมูลสำเร็จ'
        this.color = 'green'
        this.snackbar = true
        if (data.status == 200) {
          switch (this.tab) {
            case 4:
              this.NameP = data.data.name.firstname
              this.SurNameP = data.data.name.lastname
              this.idCard = data.data.cid
              break
            case 5:
              this.NameStd = data.data.name.firstname
              this.SurNameStd = data.data.name.lastname
              this.idCardStd = data.data.cid
              break
            default:
              break
          }
        }
      });*/
      ////////////////////////////////////////////////////////////////////////////////////////////
      
      /* ปิดคอมเม้นเพื่อไปใช้รูปแบบการเรียก แบบปีงบ selProjFiscalYer เมื่อ 6 มิ.ย. 68 */
      /* this.initProjectRoundData().then(res => {
        if (res) {
          this.initProject()
        }
      }).catch(reason => {
        if (reason) {
          this.initProject()
          }
          
      }) */
     this.initProject()
    },
    initProject() {
      this.projectDataToTable = []
      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')'
        })
      }

      this.selProjFiscalYear()

      /* ปิดคอมเม้นเพื่อไปใช้รูปแบบการเรียก แบบปีงบ selProjFiscalYer เมื่อ 6 มิ.ย. 68 */
      /* if (this.projectForApprove.length > 0) {
        var projectApproveDump = this.projectForApprove.filter(item => (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7') && (item.Project_type == this.TypeProject))
        if (this.CheckAdmin) {
          this.getPermissionDep({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              projectApproveDump.map(Project => {
                if (Project.IsRoundStatus == '0') {
                  var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                  var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                  if (DepData.length > 0) {
                    if (DepBy.length > 0) {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                            ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                            ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                        full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                        Owner: true
                      })
                    } else if (DepBy.length == 0) {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                            ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                        full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                        Owner: true
                      })
                    } else {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                        full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                        Owner: true
                      })
                    }
                  }
                } else {
                  var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                  if (RoundDump.length > 0) {
                    RoundDump.map(RoundI => {
                      DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                      DepBy = this.depart.filter(depi => depi.dep_id == RoundI.Dep_Code)
                      if (DepData.length > 0) {
                        if (DepBy.length > 0) {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name +
                                '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>' +
                                ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                            full_Name2: RoundI.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                            Owner: true
                          })
                        } else if (DepBy.length == 0) {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name +
                                '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                            full_Name2: RoundI.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                            Owner: true
                          })
                        } else {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name +
                                '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>',
                            full_Name2: RoundI.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                            Owner: true
                          })
                        }
                      }
                    })
                  }
                }
              })
              this.dialogLoading = false
            } else {
              this.dialogLoading = false
            }
          })
        } else if (this.CheckSubAdmin) {
          this.getPermissionDepUserData({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              projectApproveDump.map(Project => {
                if (Project.IsRoundStatus == '0') {
                  var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                  var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                  if (DepData.length > 0) {
                    if (DepBy.length > 0) {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                            ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                            ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                        full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                        Owner: true
                      })
                    } else if (DepBy.length == 0) {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                            ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                        full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                        Owner: true
                      })
                    } else {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                        full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                        Owner: true
                      })
                    }
                  }
                } else {
                  var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                  if (RoundDump.length > 0) {
                    RoundDump.map(RoundI => {
                      DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                      DepBy = this.depart.filter(depi => depi.dep_id == RoundI.Dep_Code)
                      if (DepData.length > 0) {
                        if (DepBy.length > 0) {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name +
                                '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>' +
                                ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                            full_Name2: RoundI.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                            Owner: true
                          })
                        } else if (DepBy.length == 0) {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name +
                                '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>' +
                                ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                            full_Name2: RoundI.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                            Owner: true
                          })
                        } else {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name +
                                '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>',
                            full_Name2: RoundI.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                            Owner: true
                          })
                        }
                      }
                    })
                  }
                }
              })
              this.dialogLoading = false
            } else {
              this.dialogLoading = false
            }
          })
        }
      } else {
        this.dialogLoading = false
      } */

      this.initPositionsData()

      this.initProjectGroupData()

      this.initlevelData()

      this.initCardData()

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })
    },
    openExportOptionsDialog() {
      this.dialogExportOptions = true;
    },    
    confirmExportWithOptions() {
      this.dialogExportOptions = false;
      this.ExportEmpData();
    },    
    getFilteredJsonFields() {
      // กรองข้อมูลจาก exportFields ที่มีค่า value = true
      const filteredFields = {};
      
      // สร้าง mapping ระหว่าง exportFields keys กับ json_fields keys ตามของเดิม
      const fieldMapping = {
        employeeId: 'รหัสบุคลากร',      // 'perid'
        prefix: 'คำนำหน้า',            // 'iname'
        firstName: 'ชื่อ',             // 'name'
        lastName: 'นามสกุล',          // 'surname'
        department: 'หน่วยงาน',        // 'dep_name'
        position: 'ตำแหน่ง',          // 'pos_name'
        religion: 'ศาสนา',            // 'religion_name'
        academicBudget: 'งบวิชาการตามสิทธิ์ที่ได้รับ', // 'money_permiss'
        remarks: 'หมายเหตุ',           // 'remark'
        licenseNumber: 'เลขใบอนุญาต'  // 'LicenseID'
      };

      // กำหนด json_fields เดิมทั้งหมดเพื่อใช้เป็นฐาน
      const originalJsonFields = {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
        "เลขใบอนุญาต": 'license_id',
      };

      // เพิ่มลำดับเป็น field แรกเสมอ
      filteredFields['ลำดับ'] = originalJsonFields['ลำดับ'];

      // วนลูปตรวจสอบ exportFields และเพิ่มเฉพาะ fields ที่ถูกเลือก
      Object.keys(this.exportFields).forEach(key => {
        if (this.exportFields[key].value && fieldMapping[key]) {
          const fieldLabel = fieldMapping[key];
          if (originalJsonFields[fieldLabel]) {
            filteredFields[fieldLabel] = originalJsonFields[fieldLabel];
          }
        }
      });

      return filteredFields;
    },
    ExportEmpData() {
      this.json_data = []
      this.array_title = []
      var staff = []
      if (this.project.DateStart == '' || this.project.DateEnd == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน'
        })
      } else {
        // เรียกใช้ฟังก์ชันเพื่อกรอง json_fields ตาม exportFields ที่เลือก
        this.json_fields = this.getFilteredJsonFields();
        
        this.array_title.push(this.project.Project_name)
        if (this.project.IsRoundStatus == '1') {
          this.array_title.push('รุ่นที่ ' + this.project.Round + ' ชื่อรุ่น ' + this.project.Round_name)
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE))
        } else {
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))
        }
        this.array_title.push('สถานที่ ' + this.project.Location)
        if (this.RequestPerson.length > 0) {
          this.RequestPerson.map((item, idx) => {
            staff = this.staffData.filter(value => value.perid == item.uid)
            if (staff.length > 0) {
              if (parseInt(staff[0].salary) > 20000) {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  iname: staff[0].iname || '',
                  name: staff[0].name,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name_old,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: '',
                  index: idx + 1,
                  money_permiss: '15500',
                  license_id: staff[0].license_id || '',
                })
              } else {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  iname: staff[0].iname || '',
                  name: staff[0].name,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name_old,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: '',
                  index: idx + 1,
                  money_permiss: '11000',
                  license_id: staff[0].license_id || '',
                })
              }
            }
          })
          this.json_data = this.json_data.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
          this.json_data.map((item, idx) => {
            item.index = (idx + 1)
          })
        }
      }
    },
    ExportData() {
      this.json_data_export = []
      this.array_title = []
      if (this.project.DateStart == '' || this.project.DateEnd == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน'
        })
      } else {
        this.array_title.push(this.project.Project_name)
        if (this.project.IsRoundStatus == '1') {
          this.array_title.push('รุ่นที่ ' + this.project.Round + ' ชื่อรุ่น ' + this.project.Round_name)
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE))
        } else {
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))
        }
        this.array_title.push('สถานที่ ' + this.project.Location)
        if (this.RequestPerson.length > 0) {
          this.RequestPerson.map((item, idx) => {
            this.json_data_export.push({
              ...item,
              index: idx + 1,
              full_Name: item.name + ' ' + item.sname
            })
          })
        }
        this.json_data_export = this.json_data_export.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
        this.json_data_export.map((item, idx) => {
          item.index = (idx + 1)
        })
      }
    },
    ImportDataToDb() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการนำเข้าข้อมูลใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          if (this.empData.length > 0) {
            this.empData.map(async (staff_I, idx) => {
              await this.insertDataToDB({
                Project_code: this.project.Project_code,
                D_project_round_id: this.project.id,
                uid: staff_I.uid,
                name: staff_I.name,
                sname: staff_I.sname,
                id_card: staff_I.idCard,
                affiliation: staff_I.affiliation,
                position: '',
                phone: '',
                registerType_id: staff_I.registerType_id,
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              })
              if (idx == this.empData.length - 1) {
                this.dialogLoading = false
                this.closeDi_ImportDataEmp()
                this.getJoinProject()
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม จากไฟล์นำเข้า สำเร็จ!!'
                })
              }
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถนำเข้าข้อมูลได้ เนื่องจากไม่พบข้อมูลรายชื่อบุคลากรที่ต้องการจะนำเข้า'
            })
          }
        }
      })
    },
    UploadFilesToDb(Project_code, Round_id, perid) {
      var countFilePerson = 0
      this.FilePerson.map((item) => {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files', {
          Project_code: Project_code,
          D_project_round_id: Round_id,
          perid: perid,
          File_name: item.name,
          File_path: item.path,
          File_type: item.type_Img,
          Create_By: this.MeData[0].perid,
          Create_Time: 'now()',
        }, {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }).then(res => {
          if (res.data.status) {
            countFilePerson++
            if (countFilePerson == this.FilePerson.length) {
              this.FilePerson = []
              this.filesP = []
              this.txtAlertP = []
              this.alertP = false
            }
          }
        })
      })
    },
    checkShowData(item) {
      if (item.File_name.indexOf('.rar') >= 0) {
        return false;
      } else if (item.File_type == 'application/x-zip-compressed') {
        return false;
      } else {
        switch (item.File_type) {
          case 'image/jpg':
          case 'image/jpeg':
          case 'image/gif':
          case 'image/bmp':
          case 'image/png':
            return true;
          case 'application/pdf':
            return true;
          default:
            return false;
        }
      }
    },
    downloadTemplateEmp() {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'Template ตัวอย่าง การนำเข้าข้อมูลบุคลากรผู้เข้าร่วม');
      link.href = 'https://medhr.medicine.psu.ac.th/HrTrain2/' + (this.typeImport == '1' ? 'TemplateEmp.xlsx' : this.typeImport == '2' ? 'TemplateStudent.xlsx' : 'TemplateEmpOther.xlsx')
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadFiles(item) {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', item.File_name);
      link.href = this.Openfile + item.File_path;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    ShowData(dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    ShowFile(item) {
      this.personObj = null
      this.personObj = item
      this.dialogFile = true
    },
    importExcelData(type) {
      this.typeImport = type
      this.DialogImportEmp = true
    },
    ChooseSheetAction() {
      this.empHeaders = []
      this.empData = []
      this.Exec = false
      this.ShowAlertErrImp = false
      this.MessageErrorImp = ''
      var CheckDupe = false
      var empDataDump = []
      var textID = ''
      readXlsxFile(this.filesImportEmp[0], {sheet: this.ChooseSheet}).then((row) => {
        row.map((items, index) => {
          var obj = {};
          items.map((data, idx) => {
            if (index == 0) {
              this.empHeaders.push({
                text: data,
                value: 'keys' + idx,
              })
            } else {
              obj['keys' + idx] = data;
              textID += "'" + data + "',"
              if (idx == items.length - 1) {
                empDataDump.push(obj)
              }
            }
          })
        })
        if (textID != '') {
          textID = textID.slice(0, -1);
        }
        if (this.typeImport == '1') {
          if (empDataDump.length > 0) {
            // กรอง itemEmp.keys0 ที่ซ้ำออก ให้เหลือแค่ 1 รายการ
            const uniqueEmpDataDump = [];
            const seenKeys = new Set();
            empDataDump.forEach(itemEmp => {
              if (itemEmp.keys0 && !seenKeys.has(itemEmp.keys0)) {
                uniqueEmpDataDump.push(itemEmp);
                seenKeys.add(itemEmp.keys0);
              }
            });

            uniqueEmpDataDump.map(itemEmp => {
              CheckDupe = false
              this.staffData.map(async (staff_I) => {
                if (staff_I.perid == itemEmp.keys0) {
                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.empData.push({
                      idEmp: this.empData.length,
                      ...staff_I,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      position: '',
                      phone: '',
                      registerType_id: 0,
                      join_status: '0',
                      files: []
                    })
                  } else {
                    this.MessageErrorImp += '<p style="font-weight: bold;color: red"">' + staff_I.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                    this.ShowAlertErrImp = true
                  }
                }
              })
            })
          }
        } else if (this.typeImport == '2') {
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'getStdMedPSU',
            param: btoa(encodeURIComponent(JSON.stringify({
              queryId: textID,
            })))
          }).then(res => {
            if (res.data.length > 0) {
              if (empDataDump.length > 0) {
                // กรอง itemEmp.keys0 ที่ซ้ำออก ให้เหลือแค่ 1 รายการ
                const uniqueEmpDataDump = [];
                const seenKeys = new Set();
                empDataDump.forEach(itemEmp => {
                  if (itemEmp.keys0 && !seenKeys.has(itemEmp.keys0)) {
                    uniqueEmpDataDump.push(itemEmp);
                    seenKeys.add(itemEmp.keys0);
                  }
                });

                uniqueEmpDataDump.map(itemEmp => {
                  CheckDupe = false
                  res.data.map(async (stdI) => {
                    if (stdI.STUDENT_ID == itemEmp.keys0) {
                      if (this.RequestPerson.filter(item => item.uid == stdI.STUDENT_ID).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.empData.push({
                          idEmp: this.empData.length,
                          ...stdI,
                          uid: stdI.STUDENT_ID,
                          full_Name: stdI.STUD_NAME_THAI + ' ' + stdI.STUD_SNAME_THAI,
                          name: stdI.STUD_NAME_THAI,
                          sname: stdI.STUD_SNAME_THAI,
                          idCard: stdI.CITIZEN_ID,
                          affiliation: 'นักศึกษาคณะแพทย์',
                          position: '',
                          phone: '',
                          registerType_id: 1,
                          join_status: '0',
                          files: [],
                          type_details: 'นักศึกษาคณะแพทย์'
                        })
                      } else {
                        this.MessageErrorImp += '<p style="font-weight: bold;color: red"">' + stdI.STUD_NAME_THAI + ' ' + stdI.STUD_SNAME_THAI + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                        this.ShowAlertErrImp = true
                      }
                    }
                  })
                })
              }
            }
          })
        } else {
          if (empDataDump.length > 0) {
            var count = 0
            // กรอง itemEmp.keys0 และ itemEmp.keys1 ที่ซ้ำออก ให้เหลือแค่ 1 รายการ
            const uniqueEmpDataDump = [];
            const seenKeys = new Set();
            empDataDump.forEach(itemEmp => {
              const key = itemEmp.keys0 + '|' + itemEmp.keys1; // ใช้คีย์รวมเพื่อเช็คความซ้ำ
              if (itemEmp.keys0 && itemEmp.keys1 && !seenKeys.has(key)) {
                uniqueEmpDataDump.push(itemEmp);
                seenKeys.add(key);
              }
            });
            uniqueEmpDataDump.map(itemEmp => {
              CheckDupe = false
              if (itemEmp.keys0 != null) {
                if (this.RequestPerson.filter(item => item.name == itemEmp.keys0 && item.sname == itemEmp.keys1).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  if (this.RequestPerson.length > 0) {
                    while (this.RequestPerson.filter(item => item.uid == 'P_' + count).length > 0 || this.empData.filter(item => item.uid == 'P_' + count).length > 0) {
                      count++
                    }
                  } else if(this.empData.length > 0) {
                    while (this.empData.filter(item => item.uid == 'P_' + count).length > 0) {
                      count++
                    }
                  }
                  this.empData.push({
                    idEmp: this.empData.length,
                    uid: 'P_' + count,
                    full_Name: itemEmp.keys0 + ' ' + itemEmp.keys1,
                    name: itemEmp.keys0,
                    sname: itemEmp.keys1,
                    idCard: '',
                    affiliation: itemEmp.keys2,
                    position: itemEmp.keys3,
                    phone: '',
                    registerType_id: 4,
                    join_status: '0',
                    files: [],
                    type_details: 'บุคคลภายนอก'
                  })
                } else {
                  this.MessageErrorImp += '<p style="font-weight: bold;color: red"">' + itemEmp.keys0 + ' ' + itemEmp.keys1 + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                  this.ShowAlertErrImp = true
                }
              }
            })
          }
        }

        if (this.MessageErrorImp != '') {
          this.ShowAlertErrImp = true
        }
        this.DialogExamImportEmp = true
      })
    },
    closeDi_ImportDataEmp() {
      this.ShowAlertErrImp = false
      this.MessageErrorImp = ''
      this.empData = []
      this.sheets = []
      this.ChooseSheet = ''
      this.Exec = false
      this.filesImportEmp = []
      this.DialogExamImportEmp = false
      this.DialogImportEmp = false
    },
    FileImport() {
      this.sheets = []
      this.ChooseSheet = ''
      this.Exec = false
      readXlsxFile(this.filesImportEmp[0], {getSheets: true}).then((sheets) => {
        this.sheets = sheets
      })
    },
    FileSelect() {
      // var count = 0
      this.txtAlertP = []
      this.FilePerson = []
      this.alertP = false
      if (this.filesP.length > 0) {
        this.filesP.map((item) => {
          var Checkfile = false;
          if (item.name.indexOf('.rar') >= 0) {
            Checkfile = true;
          } else if (item.type == 'application/x-zip-compressed') {
            Checkfile = true;
          } else {
            switch (item.type) {
              case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
              case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                Checkfile = true;
                break
              case 'application/pdf':
                Checkfile = true;
                break
              default:
                Checkfile = false;
                break
            }
          }

          if (Checkfile) {
            if (item.size > 25000000) {
              this.txtAlertP.push({
                id: this.txtAlertP.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 25 mb*'
              })
            }
          } else {
            this.txtAlertP.push({
              id: this.txtAlertP.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type + ' ( ' + item.name + ' ) '
            })
          }
        })
        // setTimeout(() => {
        //   this.alert = false
        // }, 3000)
      }

      if (this.txtAlertP.length == 0) {
        this.dialogLoading = true
        var idx = 0
        if (this.filesP.length > 0) {
          this.filesP.map(async (item) => {
            const fd = new FormData()
            fd.append('file', item, item.name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            await axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                if (item.name.indexOf('.rar') >= 0) {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'rar',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: item.type
                  })
                } else if (item.type == 'application/x-zip-compressed') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'zip',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: item.type
                  })
                } else if (item.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'ppt',
                    type_Img: item.type
                  })
                } else if (item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'word',
                    type_Img: item.type
                  })
                } else {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FilePerson.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type,
                        File_name: item.name,
                        File_path: res.data.path,
                        File_type: item.type
                      })
                      break
                    case 'application/pdf':
                      this.FilePerson.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type,
                        File_name: item.name,
                        File_path: res.data.path,
                        File_type: item.type
                      })
                      break
                    default:
                      break
                  }
                }
              }
              idx++
              if (idx == this.filesP.length) {
                this.dialogLoading = false
              }
            })
          })
        } else {
          this.dialogLoading = false
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากพบไฟล์ ไม่เข้าเงื่อนไขการอัพโหลด โปรดตรวจสอบข้อความข้อผิดพลาดพร้อมแก้ไขและลองอีกครั้ง!!'
        })
        this.alertP = true
      }

    },
    insertPersonUni() {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.personalMedData.map(value => {
              if (this.IdPersonal == value.STAFF_ID) {
                if (this.RequestPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.RequestPerson.unshift({
                    ...value,
                    uid: value.STAFF_ID,
                    full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    idCard: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    join_status: '0',
                    files: [],
                    type_details: 'บุคลากรคณะอื่น'
                  })
                  this.IdPersonal = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: value.STAFF_ID,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    id_card: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.personalMedData.map(value => {
              if (this.IdPersonal == value.STAFF_ID) {
                if (this.RequestPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.RequestPerson.unshift({
                    ...value,
                    uid: value.STAFF_ID,
                    full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    idCard: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    join_status: '0',
                    files: [],
                    type_details: 'บุคลากรคณะอื่น'
                  })
                  this.IdPersonal = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: value.STAFF_ID,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    id_card: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    insertStd(msg) {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (msg == 'med') {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.RequestPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.RequestPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      join_status: '0',
                      files: [],
                      type_details: 'นักศึกษาคณะแพทย์'
                    })
                    this.Idstudent = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              })
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.RequestPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.RequestPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      join_status: '0',
                      files: [],
                      type_details: 'นักศึกษาคณะอื่น'
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }

                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (msg == 'med') {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.RequestPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.RequestPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      join_status: '0',
                      files: [],
                      type_details: 'นักศึกษาคณะแพทย์'
                    })
                    this.Idstudent = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              })
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.RequestPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.RequestPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      join_status: '0',
                      files: [],
                      type_details: 'นักศึกษาคณะอื่น'
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }

                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    Del_item_ImportEmp(idx) {
      this.empData.map((item, index) => {
        if (item.idEmp == idx) {
          this.empData.splice(index, 1)
        }
      })
    },
    clearRequestProject(ProjectCode) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + ProjectCode, {
        active: '0',
        Update_By: this.MeData[0].perid
      })
    },
    Del_item(item) { /* การลบข้อมูลหลังจาก import ไม่สามารถลบได้ทันทีเนื่องจาก item.join_id ไม่มีข้อมูลรอแก้ไข 12 ก.ค. 67*/
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.RequestPerson = this.RequestPerson.filter(value => value.uid != item.uid)
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                // 'X-REST-METHOD': 'DELETE'
              }
            }
            // if (this.RequestPerson.length > 0) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/id/' + item.join_id, {
              active: '0',
              Update_By: this.MeData[0].perid
            }, headerAxios).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'ลบข้อมูลผู้เข้าร่วม ' + item.full_Name + ' สำเร็จ!!'
                })
              }
            })
            // }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.RequestPerson = this.RequestPerson.filter(value => value.uid != item.uid)
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                // 'X-REST-METHOD': 'DELETE'
              }
            }
            // if (this.RequestPerson.length > 0) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/id/' + item.join_id, {
              active: '0',
              Update_By: this.MeData[0].perid
            }, headerAxios).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'ลบข้อมูลผู้เข้าร่วม ' + item.full_Name + ' สำเร็จ!!'
                })
              }
            })
            // }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s()
      }
    },
    ChooseEmpolyee_c(event) {
      var GetData = []
      var CheckDupe = false
      var checkPermiss = false
      if (this.PermissionAdmin.length > 0) {
        if (event.key == "Enter") {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
              if (GetData.length > 0) {
                if (this.RequestPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.RequestPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    join_status: '0',
                    files: [],
                    type_details: 'บุคลากรคณะแพทย์'
                  })
                  this.cardSel = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }

              }
            } else {
              if (!checkPermiss && idx == this.PermissionAdmin.length - 1) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      } else {
        if (event.key == "Enter") {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
              if (GetData.length > 0) {
                if (this.RequestPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.RequestPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    join_status: '0',
                    files: [],
                    type_details: 'บุคลากรคณะแพทย์'
                  })
                  this.cardSel = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            } else {
              if (!checkPermiss && idx == this.Permission.length - 1) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckPermiss = false
      console.log(this.staffSel)
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.staffData.map(async (staff_I) => {
              if (staff_I.perid == this.staffSel) {
                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.RequestPerson.unshift({
                    ...staff_I,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    join_status: '0',
                    files: (this.FilePerson.length > 0 ? this.FilePerson : []),
                    type_details: 'บุคลากรคณะแพทย์'
                  })
                  this.staffSel = ''
                  if (this.FilePerson.length > 0) {
                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                  }
                  await this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    id_card: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }

              }
            })
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.staffData.map(async (staff_I) => {
              if (staff_I.perid == this.staffSel) {
                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.RequestPerson.unshift({
                    ...staff_I,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    join_status: '0',
                    files: (this.FilePerson.length > 0 ? this.FilePerson : []),
                    type_details: 'บุคลากรคณะแพทย์'
                  })
                  this.staffSel = ''
                  if (this.FilePerson.length > 0) {
                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                  }
                  await this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    id_card: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }

              }
            })
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    insertDataPerson(type) {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (type == 'person') {
              if (this.NameP != '' && this.SurNameP != '') {
                if (this.RequestPerson.filter(item => item.uid == ('P_' + this.RequestPerson.length)).length > 0) {
                  CheckDupe = true
                }
                this.RequestPerson.unshift({
                  uid: (!CheckDupe ? 'P_' + this.RequestPerson.length : 'P_' + (this.RequestPerson.length + 1)),
                  full_Name: this.NameP + ' ' + this.SurNameP,
                  name: this.NameP,
                  sname: this.SurNameP,
                  idCard: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                  join_status: '0',
                  files: [],
                  type_details: 'บุคคลภายนอก'
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: (!CheckDupe ? 'P_' + this.RequestPerson.length : 'P_' + (this.RequestPerson.length + 1)),
                  name: this.NameP,
                  sname: this.SurNameP,
                  id_card: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()'
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                })
                this.NameP = ''
                this.SurNameP = ''
                this.idCard = ''
                this.affiliation = ''
                this.position = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดกรอก ชื่อ - สกุล ให้ครบถ้วน'
                })
              }
            } else {
              if (this.NameStd != '' && this.SurNameStd != '') {
                if (this.RequestPerson.filter(item => item.uid == ('S_' + this.RequestPerson.length)).length > 0) {
                  CheckDupe = true
                }
                this.RequestPerson.unshift({
                  uid: (!CheckDupe ? 'S_' + this.RequestPerson.length : 'S_' + (this.RequestPerson.length + 1)),
                  full_Name: this.NameStd + ' ' + this.SurNameStd,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  idCard: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                  join_status: '0',
                  files: [],
                  type_details: 'นักศึกษาภายนอก'
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: (!CheckDupe ? 'S_' + this.RequestPerson.length : 'S_' + (this.RequestPerson.length + 1)),
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  id_card: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameStd + ' ' + this.SurNameStd + ' สำเร็จ!!'
                })
                this.NameStd = ''
                this.SurNameStd = ''
                this.idCardStd = ''
                this.affiliationStd = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดกรอก ชื่อ - สกุล ให้ครบถ้วน'
                })
              }
            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (type == 'person') {
              if (this.NameP != '' && this.SurNameP != '') {
                if (this.RequestPerson.filter(item => item.uid == ('P_' + this.RequestPerson.length)).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.RequestPerson.unshift({
                    uid: (!CheckDupe ? 'P_' + this.RequestPerson.length : 'P_' + (this.RequestPerson.length + 1)),
                    full_Name: this.NameP + ' ' + this.SurNameP,
                    name: this.NameP,
                    sname: this.SurNameP,
                    idCard: this.idCard,
                    affiliation: this.affiliation,
                    position: this.position,
                    phone: this.phoneOther,
                    registerType_id: 4,
                    join_status: '0',
                    files: [],
                    type_details: 'บุคคลภายนอก'
                  })
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: (!CheckDupe ? 'P_' + this.RequestPerson.length : 'P_' + (this.RequestPerson.length + 1)),
                    name: this.NameP,
                    sname: this.SurNameP,
                    id_card: this.idCard,
                    affiliation: this.affiliation,
                    position: this.position,
                    phone: this.phoneOther,
                    registerType_id: 4,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                  })
                  this.NameP = ''
                  this.SurNameP = ''
                  this.idCard = ''
                  this.affiliation = ''
                  this.position = ''
                  this.phoneOther = ''
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดกรอก ชื่อ - สกุล ให้ครบถ้วน'
                })
              }
            } else {
              if (this.NameStd != '' && this.SurNameStd != '') {
                if (this.RequestPerson.filter(item => item.uid == ('S_' + this.RequestPerson.length)).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.RequestPerson.unshift({
                    uid: (!CheckDupe ? 'S_' + this.RequestPerson.length : 'S_' + (this.RequestPerson.length + 1)),
                    full_Name: this.NameStd + ' ' + this.SurNameStd,
                    name: this.NameStd,
                    sname: this.SurNameStd,
                    idCard: this.idCardStd,
                    affiliation: this.affiliationStd,
                    position: '',
                    phone: this.phoneOther,
                    registerType_id: 5,
                    join_status: '0',
                    files: [],
                    type_details: 'นักศึกษาภายนอก'
                  })
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: (!CheckDupe ? 'S_' + this.RequestPerson.length : 'S_' + (this.RequestPerson.length + 1)),
                    name: this.NameStd,
                    sname: this.SurNameStd,
                    id_card: this.idCardStd,
                    affiliation: this.affiliationStd,
                    position: '',
                    phone: this.phoneOther,
                    registerType_id: 5,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameStd + ' ' + this.SurNameStd + ' สำเร็จ!!'
                  })
                  this.NameStd = ''
                  this.SurNameStd = ''
                  this.idCardStd = ''
                  this.affiliationStd = ''
                  this.phoneOther = ''
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'โปรดกรอก ชื่อ - สกุล ให้ครบถ้วน'
                })
              }
            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    SaveToTable() {
      var CheckDupe = false
      var CheckPermiss = false
      this.MessageError = ''
      this.MessageSuc = ''
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.EmpData.map((item) => {
              CheckDupe = false
              if (this.RequestPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.RequestPerson.unshift({
                  ...item,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  idCard: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                  join_status: '0',
                  files: [],
                  type_details: 'บุคลากรคณะแพทย์'
                })

                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: item.perid,
                  name: item.name.split(' ')[0],
                  sname: item.surname,
                  id_card: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                this.ShowAlertSuc = true
              } else {
                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                this.ShowAlertErr = true
              }
            })
            this.EmpData = []
            this.items = []
            this.departSel = ''
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.EmpData.map((item) => {
              CheckDupe = false
              if (this.RequestPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.RequestPerson.unshift({
                  ...item,
                  uid: item.perid,
                  name: item.name,
                  sname: item.surname,
                  idCard: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                  join_status: '0',
                  files: [],
                  type_details: 'บุคลากรคณะแพทย์'
                })

                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: item.perid,
                  name: item.name.split(' ')[0],
                  sname: item.surname,
                  id_card: item.citizen_id,
                  affiliation: item.dep_name,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                this.ShowAlertSuc = true
              } else {
                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                this.ShowAlertErr = true
              }
            })
            this.EmpData = []
            this.items = []
            this.departSel = ''
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    showDetails: async function (item) {
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        this.project = item
        this.Project_name = this.project.Project_name
        this.Details_Cordi = true;
        this.RequestPerson = []
        var url = ''
        if (item.IsRoundStatus == '0') {
          url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + item.Project_code + '/active/1/?limit=9999'
        } else {
          url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + item.Project_code + '/active/1/D_project_round_id/' + item.Ref_id + '/?limit=9999'
        }

        await this.initPersonFileData({
          Project_code: item.Project_code
        }).catch(res => {
          if (res) {
            console.log('no files in project')
          }
        })

        axios.get(url).then(res => {
          if (res.data) {
            var checkMatch = false
            if (res.data.length > 0) {
              res.data.map((itemJ) => {
                checkMatch = false
                if (this.project.IsRoundStatus == '0') {
                  if (itemJ.D_project_round_id == '' || itemJ.D_project_round_id == null) {
                    this.staffData.map(staff_i => {
                      if (staff_i.perid == itemJ.uid) {
                        checkMatch = true
                        this.RequestPerson.unshift({
                          ...staff_i,
                          ...itemJ,
                          full_Name: itemJ.name + ' ' + itemJ.sname,
                          idCard: itemJ.id_card,
                          files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                        })
                      }
                    })
                    if (!checkMatch) {
                      this.RequestPerson.unshift({
                        ...itemJ,
                        full_Name: itemJ.name + ' ' + itemJ.sname,
                        idCard: itemJ.id_card,
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                      })
                    }
                  }
                } else {
                  this.staffData.map(staff_i => {
                    if (staff_i.perid == itemJ.uid) {
                      checkMatch = true
                      this.RequestPerson.unshift({
                        ...staff_i,
                        ...itemJ,
                        full_Name: itemJ.name + ' ' + itemJ.sname,
                        idCard: itemJ.id_card,
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                      })
                    }
                  })
                  if (!checkMatch) {
                    this.RequestPerson.unshift({
                      ...itemJ,
                      full_Name: itemJ.name + ' ' + itemJ.sname,
                      idCard: itemJ.id_card,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                    })
                  }
                }
              })
            } else {
              checkMatch = false
              if (this.project.IsRoundStatus == '0') {
                if (res.data.D_project_round_id == '' || res.data.D_project_round_id == null) {
                  this.staffData.map(staff_i => {
                    if (staff_i.perid == res.data.uid) {
                      checkMatch = true
                      this.RequestPerson.unshift({
                        ...staff_i,
                        ...res.data,
                        full_Name: res.data.name + ' ' + res.data.sname,
                        idCard: res.data.id_card,
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == res.data.uid) : [])
                      })
                    }
                  })
                  if (!checkMatch) {
                    this.RequestPerson.unshift({
                      ...res.data,
                      full_Name: res.data.name + ' ' + res.data.sname,
                      idCard: res.data.id_card,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == res.data.uid) : [])
                    })
                  }
                }
              } else {
                this.staffData.map(staff_i => {
                  if (staff_i.perid == res.data.uid) {
                    checkMatch = true
                    this.RequestPerson.unshift({
                      ...staff_i,
                      ...res.data,
                      full_Name: res.data.name + ' ' + res.data.sname,
                      idCard: res.data.id_card,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == res.data.uid) : [])
                    })
                  }
                })
                if (!checkMatch) {
                  this.RequestPerson.unshift({
                    ...res.data,
                    full_Name: res.data.name + ' ' + res.data.sname,
                    idCard: res.data.id_card,
                    files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == res.data.uid) : [])
                  })
                }
              }
            }
          } else {
            this.RequestPerson = []
          }
        })
      }
    },
    getJoinProject: async function () {
      this.Details_Cordi = true;
      this.RequestPerson = []
      var url = ''
      if (this.project.IsRoundStatus == '0') {
        url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + this.project.Project_code + '/active/1/?limit=9999'
      } else {
        url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + this.project.Project_code + '/active/1/D_project_round_id/' + this.project.Ref_id + '/?limit=9999'
      }

      await this.initPersonFileData({
        Project_code: this.project.Project_code
      }).catch(res => {
        if (res) {
          console.log('no files in project')
        }
      })

      axios.get(url).then(res => {
        if (res.data) {
          var checkMatch = false
          if (res.data.length > 0) {
            res.data.map((itemJ) => {
              checkMatch = false
              if (this.project.IsRoundStatus == '0') {
                if (itemJ.D_project_round_id == '' || itemJ.D_project_round_id == null) {
                  this.staffData.map(staff_i => {
                    if (staff_i.perid == itemJ.uid) {
                      checkMatch = true
                      this.RequestPerson.unshift({
                        ...staff_i,
                        ...itemJ,
                        full_Name: itemJ.name + ' ' + itemJ.sname,
                        idCard: itemJ.id_card,
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                      })
                    }
                  })
                  if (!checkMatch) {
                    this.RequestPerson.unshift({
                      ...itemJ,
                      full_Name: itemJ.name + ' ' + itemJ.sname,
                      idCard: itemJ.id_card,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                    })
                  }
                }
              } else {
                this.staffData.map(staff_i => {
                  if (staff_i.perid == itemJ.uid) {
                    checkMatch = true
                    this.RequestPerson.unshift({
                      ...staff_i,
                      ...itemJ,
                      full_Name: itemJ.name + ' ' + itemJ.sname,
                      idCard: itemJ.id_card,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                    })
                  }
                })
                if (!checkMatch) {
                  this.RequestPerson.unshift({
                    ...itemJ,
                    full_Name: itemJ.name + ' ' + itemJ.sname,
                    idCard: itemJ.id_card,
                    files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == itemJ.Project_code && itemP.perid == itemJ.uid) : [])
                  })
                }
              }
            })
          } else {
            checkMatch = false
            if (this.project.IsRoundStatus == '0') {
              if (res.data.D_project_round_id == '' || res.data.D_project_round_id == null) {
                this.staffData.map(staff_i => {
                  if (staff_i.perid == res.data.uid) {
                    checkMatch = true
                    this.RequestPerson.unshift({
                      ...staff_i,
                      ...res.data,
                      full_Name: res.data.name + ' ' + res.data.sname,
                      idCard: res.data.id_card,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == res.data.uid) : [])
                    })
                  }
                })
                if (!checkMatch) {
                  this.RequestPerson.unshift({
                    ...res.data,
                    full_Name: res.data.name + ' ' + res.data.sname,
                    idCard: res.data.id_card,
                    files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == res.data.uid) : [])
                  })
                }
              }
            } else {
              this.staffData.map(staff_i => {
                if (staff_i.perid == res.data.uid) {
                  checkMatch = true
                  this.RequestPerson.unshift({
                    ...staff_i,
                    ...res.data,
                    full_Name: res.data.name + ' ' + res.data.sname,
                    idCard: res.data.id_card,
                    files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == res.data.uid) : [])
                  })
                }
              })
              if (!checkMatch) {
                this.RequestPerson.unshift({
                  ...res.data,
                  full_Name: res.data.name + ' ' + res.data.sname,
                  idCard: res.data.id_card,
                  files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == res.data.uid) : [])
                })
              }
            }
          }
        } else {
          this.RequestPerson = []
        }
      })
    },
    insertDataToDB(RegObj) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', RegObj, {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      })
    },
    GetDateTime() {
      var date;
      date = new Date();
      date = date.getUTCFullYear() + '-' +
          ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('00' + date.getUTCDate()).slice(-2) + ' ' +
          ('00' + date.getUTCHours()).slice(-2) + ':' +
          ('00' + date.getUTCMinutes()).slice(-2) + ':' +
          ('00' + date.getUTCSeconds()).slice(-2);
      return date
    },
    selProjFiscalYear() {
      this.dialogLoading = true;
      this.projectDataToTable = []
      this.projectApproveDump = []
      this.initProjDataFromFiscalYearUser2({
        FiscalYear: this.FiscalYear,
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
      }).then((res) => {
        if (res) {
          if (this.ProjectFromFiscalYearUser.length > 0) {
            var projectApproveDump = this.ProjectFromFiscalYearUser.filter(item => (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7') && (item.Project_type == this.TypeProject))
            projectApproveDump.map(Project => {
              if (Project.IsRoundStatus == '0') {
                  this.projectDataToTable.push({
                    ...Project,
                    idx: this.projectDataToTable.length,
                    Ref_id: this.projectDataToTable.length,
                    full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                        ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + Project.dep_name + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                    full_Name2: Project.Project_name.replace(/&quot;/g, '"'),
                    Owner: true
                  })
              } else {
                if (Project.round.length > 0) {
                  Project.round.map(RoundI => {
                    this.projectDataToTable.push({
                      ...Project,
                      ...RoundI,
                      idx: this.projectDataToTable.length,
                      Ref_id: RoundI.id,
                      full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                          '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + (RoundI.Round_name != null ? RoundI.Round_name : '') + ')</span>' +
                          ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + Project.dep_name + '</span></div>' +
                          ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                      full_Name2: Project.Project_name.replace(/&quot;/g, '"') + ' -> ( รุ่น ' + RoundI.Round + ' ' + (RoundI.Round_name != null ? RoundI.Round_name : '') + ')',
                      Owner: true
                    })
                  })
                }
              }
            })
            this.dialogLoading = false
          } else {
            this.$swal.fire({
              icon: "error",
              title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
          });
        }
      }).catch((res) => {
        console.log(res);
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
  },
  mounted() {
    this.dialogLoading = true
    this.changeHeaderPage({
      page: '2'
    })
    this.changeJoinProjectPage({
      page: '1'
    })
    for (var l = 2020; l <= (new Date().getFullYear() + 3); l++) {
      this.FiscalYearDataSel.push({
        year: l,
        yearth: l + 543
      })
    }
    this.FiscalYear = new Date().getFullYear()
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '10',
          page_sub_id: '9',
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '7000') {
                this.getSubMenuPermissData().then(res => {
                  if (res) {
                    if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '9' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '9' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                      this.dialogLoading = false
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '9' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                    this.dialogLoading = false
                  }
                })
                this.CheckAdmin = true
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.dialogLoading = false
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '7000') {
                    this.getSubMenuPermissData().then(res => {
                      if (res) {
                        if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '9' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '9' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                          this.dialogLoading = false
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '9' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                        this.dialogLoading = false
                      }
                    })
                    this.CheckSubAdmin = true
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
